import { chartKeys } from 'utils/constant';

const performance_months = {
  chartTitle: 'Performance By Months',
  chartKey: chartKeys.PERFORMANCE_BY_MONTHS,
}

export default performance_months;